import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import { renderToString } from "react-dom/server";
import jsPDF from "jspdf";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import ReportTemplate from "./ReportTemplate";
import Qrcode from "./Qrcode";

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center",
};
const page = {
  /*  pageBreakAfter: "always", */
  fontSize: 10,
  background: "white",
  padding: 10,
};
const td = {
  borderBottom: "1px solid #ddd",
  paddingBottom: 10,
  paddingTop: 10,
};
const th = {
  borderBottom: "1px solid #ddd",
  paddingBottom: 10,
  paddingTop: 10,
};
const colstyle = {
  width: "30%",
};
const tableStyle = {
  width: "100%",
};
const Jspdfrenderqrcode = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [tablearr, setTablearr] = useState([]);
  //use effects
  useEffect(() => {
    setTablearr(props.pdfarr);
  }, []);
  const Prints = () => (
    <div style={page}>
      <h3 style={{ textAlign: "start" }}>Invoice</h3>
      {/* {qrcodearr.length > 0 ? (
            <div>
              <div className="d-flex flex-wrap">
                {qrcodearr.map((qrcodearr, index) => (
                  <div className="me-3 mb-3" key={index}>
                    <Qrcode aircon_id={qrcodearr} />
                  </div>
                ))}
              </div>
              <div><a>print</a></div>
            </div>
          ) : (
            <div className="text-center p-3">0 record found</div>
          )} */}
      <p>*This is computer generated invoice</p>
    </div>
  );

  const generatePDF = () => {
    const stringdiv = renderToString(<Prints />);

    var elementHTML = stringdiv;
    var doc = new jsPDF("p", "pt", "a4");
    doc.html(elementHTML, {
      callback: function (doc) {
        // Save the PDF
        const filename = new Date().toDateString() + "-invoice.pdf";
        var pageCount = doc.internal.getNumberOfPages();
        /*   doc.addPage(); */
        doc.save(filename);
      },
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      x: 0,
      y: 0,
      width: 570, //target width in the PDF document
      windowWidth: 650, //window width in CSS pixels
    });
  };
  return (
    <div>
      {/* <button onClick={print}>print</button> */}
      <div className="pb-3">
        <button className="btn btn-dark" onClick={generatePDF}>
          <i className="fa fa-print"></i> Download
        </button>
      </div>
      <div>
        <Prints />
      </div>
    </div>
  );
};

export default Jspdfrenderqrcode;
